module.exports = __WEBPACK_EXTERNAL_MODULE_60__;


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/tabs/dist/mdc.tabs","commonjs2":"@material/tabs/dist/mdc.tabs","commonjs":"@material/tabs/dist/mdc.tabs","amd":"@material/tabs/dist/mdc.tabs","umd":"@material/tabs/dist/mdc.tabs"}
// module id = 60
// module chunks = 0